// // import { DeviceEventEmitter, NativeModules } from 'react-native'
// import _get from 'lodash/get'
// import _includes from 'lodash/includes'

import React from "react"
import { NAVIGATION_ROUTES } from "../../constant"
import { getCurrentRoute } from "../../navigators/RootNavigation"

// // import { endUnity, getSpQueryForSnl, sendMessageToUnity, startUnity } from 'components/Snl/helper'
// // import { showAlert } from 'screens/commonAction/Actions'
// // import { ALERT_TYPE } from 'screens/commonAction/Constants'
// // import { GAMES } from 'screens/home/constants'
// // import { storeSnlTournamentInfo, updateMTTournamentStarting, updateTournamentStarting } from 'store/actions/gameplay'
// import store from 'store'
// import { hideModals } from 'store/actions/app'
// import { requestApiGet } from 'utils/helpers/ajax'
// import { GET_GAME_CONFIG } from 'utils/helpers/apiEndpoints'
// import { getSpEventData } from 'utils/helpers/common'
// import { JOIN_MT_TOURNAMENT_TABLE, JOIN_TOURNAMENT_TABLE, RJT, SIGN_IN_ACTION } from 'utils/helpers/constants'
// import { checkGameStartedInterval, clearCheckGameStartedInterval } from 'utils/helpers/gameplay'
// import { SCREEN_STATES, SEND_MESSAGE_UNITY } from 'components/Snl/constants'
// import { getStartedTournamentsIdMap, getTournamentJoined, getUnityInvoked, getUnityRoom } from 'store/selectors/gameplay'
// import logger, { TAG_NAMES } from 'utils/Logger'
// import { getCurrentRoute, navigateToCountdown, replace } from 'navigators/RootNavigation'
// import { initializeGameplaySocket } from 'classes/socket/gameplay'
// import { NAVIGATION_ROUTES } from 'navigators/constants'
// import { getToken } from 'utils/helpers/token'
// import { connectSocket, destroySocket, isSocketConnected } from 'classes/socket/index'
// import _isEmpty from 'lodash/isEmpty'
// import {
//   getPreSignupConfig,
//   getSocketReconnectionBackOffValue,
//   getSocketReconnectionPeriod,
//   isReconnectionBackoffEnabled
// } from 'classes/session/SessionManager'
// import { handleLeaveGame } from 'screens/gameplay/store/actions'
// import _isNil from 'lodash/isNil'
// import EventEmitter from 'events'
// import { GAMES } from '../../pages/GamePlay'

// // const { UnityModule } = NativeModules
// const { dispatch, getState } = store
// const DeviceEventEmitter = new EventEmitter()

// const MILLIS = 1000
// let beforeCountdownTimeout = null
// const MTT_TIMER_STARTED = 'MTT_TIMER_STARTED'


export function isPlayerOnLudoboard() {
  return (
    // getCurrentRoute()?.name === NAVIGATION_ROUTES.LUDOBOARD_2_4_PLAYER ||
    // getCurrentRoute()?.name === NAVIGATION_ROUTES.LUDOBOAR ||
    getCurrentRoute()?.currentPath === NAVIGATION_ROUTES.GAMEPLAY
  )
}

// export function isPlayerOnWinnerScreen() {
//   return (
//     getCurrentRoute()?.name === NAVIGATION_ROUTES.WINNER2P4P ||
//     getCurrentRoute()?.name === NAVIGATION_ROUTES.NX_WINNER
//   )
// }

// // const handleSupremeTournamentStarted = async res => {
// //   const tournamentId = res?.data?.ltid || res?.data?.mttid

// //   if (_isNil(tournamentId)) {
// //     logger(TAG_NAMES.LS_GAMEPLAY, 'Nil tournament id supreme tournament started', {
// //       isLogToFile: true,
// //       data: res.data,
// //       isLogDataToFile: true
// //     })
// //   }

// //   if (!_includes(getStartedTournamentsIdMap(getState()), tournamentId)) {
// //     if (!canStartNewGame(GAMES.LUDO)) {
// //       logger('A game is already in progress', { isLogToFile: true })
// //       return
// //     }

// //     dispatch(res?.data?.mttid ? updateMTTournamentStarting(false, tournamentId) : updateTournamentStarting(false, tournamentId))
// //     navigateToCountdown(res.data)
// //   } else {
// //     logger(TAG_NAMES.SOCKET, `Ignoring TOURNAMENT_STARTED event for ${tournamentId}`, {
// //       isBreadcrumb: true
// //     })
// //   }
// // }

// let waitBeforePollingTimeout = null
// function createWaitBeforePollingTimeout(tournamentId, gameName, time = 10) {
//   clearTimeout(waitBeforePollingTimeout)
//   waitBeforePollingTimeout = null
//   waitBeforePollingTimeout = setTimeout(() => {
//     checkGameStartedInterval(tournamentId, gameName)
//   }, time * MILLIS)
// }

// // const handleSNLTournamentStarted = res => {
// //   const { timer = 0, ltid: tournamentId } = res?.data || {}
// //   const tournamentJoined = getTournamentJoined(getState())

// //   if (tournamentJoined?.gameState == SCREEN_STATES.COUNTDOWN) {
// //     sendMessageToUnity(SEND_MESSAGE_UNITY.UpdateCountDown, JSON.stringify({ offset: timer }))
// //   }

// //   if (!_includes(getStartedTournamentsIdMap(getState()), tournamentId)) {
// //     if (!canStartNewGame(GAMES.SNLT)) {
// //       return
// //     }
// //     clearTimeout(beforeCountdownTimeout)
// //     startUnity()
// //     dispatch(
// //       storeSnlTournamentInfo({
// //         name: 'ltid',
// //         data: tournamentId
// //       })
// //     )
// //     var unityRoom = getUnityRoom(getState())
// //     if (unityRoom) {
// //       // UnityModule.sendMessageToUnity(SEND_MESSAGE_UNITY.UpdateCountDown, JSON.stringify({ offset: timer }))
// //       dispatch(
// //         storeSnlTournamentInfo({
// //           name: 'gameState',
// //           data: 0
// //         })
// //       )
// //     }
// //     dispatch(updateTournamentStarting(false, tournamentId))
// //     createWaitBeforePollingTimeout(tournamentId, GAMES.SNLT, timer)
// //   } else {
// //     logger(TAG_NAMES.SOCKET, `Ignoring TOURNAMENT_STARTED event for ${tournamentId}`, {
// //       isBreadcrumb: true
// //     })
// //   }
// // }

// // const handleTournamentStarted = res => {
// //   const { gameName } = res?.data || {}

// //   if (gameName === GAMES.SNLT) {
// //     // handleSNLTournamentStarted(res)
// //   } else {
// //     handleSupremeTournamentStarted(res)
// //   }
// // }

// // const handleSupremeGameStarted = async (res, isMtt) => {
// //   dispatch(isMtt ? updateMTTournamentStarting(false) : updateTournamentStarting(false))
// //   initializeGameplaySocket(res.data.gameplayServer, {
// //     en: isMtt ? JOIN_MT_TOURNAMENT_TABLE : JOIN_TOURNAMENT_TABLE,
// //     data: res.data
// //   })
// // }

// // const handleSNLGameStarted = async res => {
// //   var { host, port, ng_idx, ng_ipx, gameName } = res?.data?.gameplayServer || {}
// //   var { uid, tableId } = res?.data || {}

// //   clearTimeout(waitBeforePollingTimeout)
// //   clearCheckGameStartedInterval()

// //   clearTimeout(beforeCountdownTimeout)
// //   // startUnity()

// //   const gameNameParams = { _gameName: gameName }
// //   dispatch(
// //     storeSnlTournamentInfo({
// //       name: 'gameNameParams',
// //       data: gameNameParams
// //     })
// //   )
// //   const eventDataParams = {
// //     eventName: JOIN_TOURNAMENT_TABLE,
// //     eventData: res?.data
// //   }
// //   dispatch(
// //     storeSnlTournamentInfo({
// //       name: 'eventDataParams',
// //       data: eventDataParams
// //     })
// //   )
// //   // const queryInfo = await getSpQueryForSnl(uid, tableId)

// //   const url = `${'wss'}://${host}:${port}`
// //   const socketParams = {
// //     gamePlayUrl: url,
// //     spRequest: queryInfo,
// //     ng_idx: ng_idx,
// //     ngIpx: ng_ipx
// //   }
// //   dispatch(
// //     storeSnlTournamentInfo({
// //       name: 'socketParams',
// //       data: socketParams
// //     })
// //   )

// //   // if (getUnityRoom(getState())) {
// //   //   UnityModule.sendMessageToUnity(SEND_MESSAGE_UNITY.SetGameName, JSON.stringify(gameNameParams))
// //   //   UnityModule.sendMessageToUnity(SEND_MESSAGE_UNITY.SetEventData, JSON.stringify(eventDataParams))
// //   //   UnityModule.sendMessageToUnity(SEND_MESSAGE_UNITY.SetSocketParams, JSON.stringify(socketParams))
// //   // }
// // }

// // const handleGameStarted = (res, isMtt = false) => {
// //   const { gameName } = res?.data?.gameplayServer
// //   dispatch(updateTournamentStarting(false)) // this line remove "Tournament Starting" bottomsheet from lobby screen
// //   if (gameName === GAMES.SNLT) {
// //     // handleSNLGameStarted(res)
// //   } else {
// //     handleSupremeGameStarted(res, isMtt)
// //   }
// // }

// // const handleSNL = async gameName => {
// //   if (gameName === GAMES.SNLT && !getUnityInvoked(getState())) {
// //     //tournament starting 10sec phle aata h
// //     clearTimeout(beforeCountdownTimeout)
// //     beforeCountdownTimeout = setTimeout(() => {
// //       // startUnity()
// //       dispatch(
// //         storeSnlTournamentInfo({
// //           name: 'gameState',
// //           data: SCREEN_STATES.BEFORE_COUNTDOWN
// //         })
// //       )
// //     }, 6000)

// //     const info = await requestApiGet(GET_GAME_CONFIG, { params: { gameName } })
// //     const { STT } = info?.data?.response?.gameConfigs?.config || {}
// //     const { isGamePlayProfileInfoEnabled } = info?.data?.response?.gameConfigs?.remoteConfig || {}
// //     dispatch(storeSnlTournamentInfo({ name: 'stt', data: STT }))
// //     dispatch(
// //       storeSnlTournamentInfo({
// //         name: 'isGamePlayProfileInfoEnabled',
// //         data: isGamePlayProfileInfoEnabled
// //       })
// //     )
// //   }
// // }

// // const handleTournamentStarting = async res => {
// //   const tournamentId = res?.data?.ltid
// //   const { gameName } = res?.data
// //   if (!_includes(getStartedTournamentsIdMap(getState()), tournamentId)) {
// //     if (!canStartNewGame(gameName)) {
// //       return
// //     }
// //     dispatch(updateTournamentStarting(true))
// //     handleSNL(gameName)
// //   } else {
// //     logger(TAG_NAMES.SOCKET, `Ignoring TOURNAMENT_STARTING event for ${tournamentId}`, {
// //       isBreadcrumb: true
// //     })
// //   }
// // }

// // const handleProfilePicRemovedNotif = async data => {
// //   try {
// //     if (_get(data, 't') === 'PROFILE_PICTURE_REMOVED') {
// //       // showAlert(data.title, ALERT_TYPE.ALERT)
// //     }
// //   } catch (error) {
// //     logger(TAG_NAMES.SOCKET, 'handleProfilePicRemovedNotif', {
// //       isBreadcrumb: true,
// //       isAddEvent: true,
// //       error
// //     })
// //   }
// // }

// // const prepareForNewGame = (gameName, isUnityInvoked) => {
// //   const params = { gameName }

// //   if (isUnityInvoked) {
// //     // endUnity()
// //     params.navigationViaSNLT = true
// //   }

// //   replace(NAVIGATION_ROUTES.LOBBY, params)
// // }

// // const canStartNewGame = (gameName = GAMES.SNLT, shouldPrepareForNewGame = true) => {
// //   const { gameState } = getTournamentJoined(getState())
// //   const isUnityInvoked = getUnityInvoked(getState())
// //   const isNativeTimeout = getCurrentRoute()?.name === NAVIGATION_ROUTES.TTO
// //   const isNativeWinner = getCurrentRoute()?.name === NAVIGATION_ROUTES.WINNER2P4P

// //   const isSNLGameplay = isUnityInvoked && gameState !== SCREEN_STATES.WINNER_SCREEN
// //   const isNativeGameplay = getCurrentRoute()?.name === NAVIGATION_ROUTES.COUNTDOWN || isPlayerOnLudoboard()

// //   if (isSNLGameplay || isNativeGameplay) {
// //     if (gameName === GAMES.SNLT && gameState === SCREEN_STATES.BEFORE_COUNTDOWN) {
// //       logger(TAG_NAMES.SOCKET, 'Unity is invoked before from tournament starting', { isLogToFile: true })
// //       return true
// //     }
// //     return false
// //   }

// //   if (isUnityInvoked || isNativeTimeout || isNativeWinner) {
// //     logger(TAG_NAMES.SOCKET, 'Removing winner or timeout screen for new game', {
// //       isBreadcrumb: true
// //     })
// //     if (shouldPrepareForNewGame) {
// //       //prepareForNewGame should be true if we are about to start a new game else false.
// //       prepareForNewGame(gameName, isUnityInvoked)
// //     }
// //   }

// //   return true
// // }

// // const hasMaxRetryExhausted = attemptNumber => {
// //   return attemptNumber > getSocketReconnectionBackOffValue()
// // }

// const showRetryExhaustedModalForNonGameScreens = () => {
//   return canStartNewGame(null, false)
// }

// function isUserOnPublicScreen() {
//   return (
//     getCurrentRoute()?.name === NAVIGATION_ROUTES.signUp ||
//     getCurrentRoute()?.name === NAVIGATION_ROUTES.login ||
//     getCurrentRoute()?.name === NAVIGATION_ROUTES.verifyOtp ||
//     getCurrentRoute()?.name === NAVIGATION_ROUTES.PICK_LANGUAGE_REVAMP ||
//     getCurrentRoute()?.name === NAVIGATION_ROUTES.ZUPEE_WEBVIEW
//   )
// }

// //This should only be called when user is logged in
// const checkMainSocketConnectionAndReconnect = async () => {
//   if (isSocketConnected()) {
//     return
//   }

//   logger(TAG_NAMES.SOCKET, 'checkMainSocketConnectionAndReconnect')

//   const token = await getToken()
//   if (_isEmpty(token)) {
//     logger(TAG_NAMES.SOCKET, 'checkMainSocketConnectionAndReconnect, No token present')
//     return
//   }

//   if (isUserOnPublicScreen()) {
//     logger(TAG_NAMES.SOCKET, `User is currently on publicScreens ${getCurrentRoute()?.name}`)
//     return
//   }

//   if (!isReconnectionBackoffEnabled()) {
//     return
//   }
//   await connectMainSocketClient()
// }

// async function connectMainSocketClient() {
//   const token = await getToken()
//   const query = await getSpEventData({ token, action: SIGN_IN_ACTION })

//   await connectSocket(getPreSignupConfig(), query)
// }

// const destroyAndRecreateSocket = async logMessage => {
//   dispatch(hideModals())
//   destroySocket(logMessage)
//   await connectMainSocketClient()
// }

// /**
//  * Get the delay for the next reconnection attempt
//  * @param attemptNumber
//  * @returns number
//  */
// const getExponentialDelay = attemptNumber => {
//   let reconnectionDelay = getSocketReconnectionPeriod()
//   let exponentialBackOff = getSocketReconnectionBackOffValue()

//   const delayInSeconds = reconnectionDelay ** (attemptNumber - 1) * exponentialBackOff
//   return delayInSeconds * 1000
// }

// // async function handleSnlRejoin(gameplayServer, tableId) {
// //   // startUnity()

// //   let queryInfo = await getSpQueryForSnl()

// //   const { host, port, proto, ng_idx, ng_ipx } = gameplayServer
// //   const url = `${'wss'}://${host}:${port}`
// //   const socketParamsData = {
// //     gamePlayUrl: url,
// //     spRequest: queryInfo,
// //     ng_idx: ng_idx,
// //     ngIpx: ng_ipx
// //   }
// //   dispatch(
// //     storeSnlTournamentInfo({
// //       name: 'socketParams',
// //       data: socketParamsData
// //     })
// //   )
// //   const gameNameParamsData = { _gameName: GAMES.SNLT }
// //   dispatch(
// //     storeSnlTournamentInfo({
// //       name: 'gameNameParams',
// //       data: gameNameParamsData
// //     })
// //   )
// //   const eventDataParamsData = {
// //     eventName: 'RJT',
// //     eventData: {
// //       _id: tableId,
// //       gt: 'normal'
// //     }
// //   }
// //   dispatch(
// //     storeSnlTournamentInfo({
// //       name: 'eventDataParams',
// //       data: eventDataParamsData
// //     })
// //   )

// //   // if (getUnityRoom(store.getState())) {
// //   //   UnityModule.sendMessageToUnity(SEND_MESSAGE_UNITY.SetGameName, JSON.stringify(gameNameParamsData))
// //   //   UnityModule.sendMessageToUnity(SEND_MESSAGE_UNITY.SetEventData, JSON.stringify(eventDataParamsData))
// //   //   UnityModule.sendMessageToUnity(SEND_MESSAGE_UNITY.SetSocketParams, JSON.stringify(socketParamsData))
// //   // }
// // }

// function handleSupremeRejoin(gameplayServer, tableId) {
//   const { ltid } = gameplayServer || {}
//   dispatch(updateTournamentStarting(false))
//   navigateToCountdown({ timer: 0, ltid: ltid })
//   initializeGameplaySocket(gameplayServer, { en: 'RJT', data: { _id: tableId, gt: 'normal' } })
// }

// async function handleRejoin(dataToSave, gameplayServer, gameName, tableId) {
//   if (!dataToSave?.accessToken || _isEmpty(dataToSave.accessToken)) {
//     logger(TAG_NAMES.APP_ACTION, 'Empty Access Token', {
//       isAddEvent: true,
//       isLogToFile: false,
//       data: {
//         message: 'Check Game Started',
//         location: 'handle rejoin'
//       }
//     })
//   }

//   if (gameName === GAMES.SNLT) {
//     // await handleSnlRejoin(gameplayServer, tableId)
//   } else {
//     handleSupremeRejoin(gameplayServer, tableId)
//   }
// }

// async function handleMttTimerStarted(res) {
//   if (getCurrentRoute()?.name === NAVIGATION_ROUTES.RPI_WINNER) {
//     DeviceEventEmitter.emit(MTT_TIMER_STARTED, { rpiTimer: res?.data?.timer })
//   }
// }

// async function handleMttSuspended(res) {
//   if (getCurrentRoute()?.name === NAVIGATION_ROUTES.LUDOBOARD_2_4_PLAYER) {
//     handleLeaveGame()
//   } else if (getCurrentRoute()?.name === NAVIGATION_ROUTES.RPI_WINNER) {
//     replace(NAVIGATION_ROUTES.MTT_SUSPENDED, { suspendReason: res?.data?.reason, mttSuspendTitle: res?.data?.mttSuspendTitle })
//   }
// }

// export {
//   handleGameStarted,
//   // handleTournamentStarted,
//   handleTournamentStarting,
//   handleProfilePicRemovedNotif,
//   getExponentialDelay,
//   canStartNewGame,
//   hasMaxRetryExhausted,
//   destroyAndRecreateSocket,
//   checkMainSocketConnectionAndReconnect,
//   showRetryExhaustedModalForNonGameScreens,
//   handleRejoin,
//   handleMttTimerStarted,
//   handleMttSuspended
// }


export {}